<template>
  <div class="order-detail" v-if="role != 'customer'">
    <h2>订单详细记录</h2>
    <el-button type="info" @click="goBack" style="margin-bottom: 10px"
      >返回</el-button
    >
    <el-form :inline="true" :model="searchForm" style="margin-bottom: 10px">
      <el-form-item label="MVB产品型号">
        <el-input
          v-model="searchForm.mvbProductModel"
          placeholder="请输入MVB产品型号"
          clearable
        />
      </el-form-item>
      <el-form-item label="产品型号">
        <el-input
          v-model="searchForm.productModel"
          placeholder="请输入产品型号"
          clearable
        />
      </el-form-item>
      <el-form-item label="产品代码">
        <el-input
          v-model="searchForm.productCode"
          placeholder="请输入产品代码"
          clearable
        />
      </el-form-item>
      <el-form-item label="条形码">
        <el-input
          v-model="searchForm.barcode"
          placeholder="请输入条形码"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="filteredOrderDetail" border style="width: 100%">
      <el-table-column
        label="PI号"
        prop="piNo"
        align="center"
      ></el-table-column>
      <el-table-column
        label="PO号"
        prop="poNo"
        align="center"
      ></el-table-column>
      <el-table-column
        label="MVB产品型号"
        prop="mvbProductModel"
        align="center"
      ></el-table-column>
      <el-table-column
        label="产品型号"
        prop="productModel"
        align="center"
      ></el-table-column>
      <el-table-column
        label="产品代码"
        prop="productCode"
        align="center"
      ></el-table-column>
      <el-table-column
        label="条形码"
        prop="barcode"
        align="center"
      ></el-table-column>
      <el-table-column
        label="订单数量"
        prop="orderQuantity"
        align="center"
      ></el-table-column>
      <el-table-column
        label="已完成数量"
        prop="completedQuantity"
        align="center"
      ></el-table-column>
      <el-table-column
        label="预计交期"
        prop="estimatedDeliveryDate"
        align="center"
      ></el-table-column>
      <!-- 保留交期列 -->
      <el-table-column
        label="更新时间"
        prop="updateTime"
        align="center"
      ></el-table-column>
      <el-table-column label="进度" align="center">
        <template #default="scope">
          <!-- 进度逻辑：单个货物的已完成数量 / 自身订单数量 * 100 -->
          <el-progress
            :percentage="scope.row.progress * 100"
            size="small"
            show-text
          ></el-progress>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageNum"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      style="margin-top: 12px; text-align: right"
    />
  </div>
  <div class="order-detail" v-else>
    <h2>Detailed record of order</h2>
    <el-button type="info" @click="goBack" style="margin-bottom: 10px"
      >return</el-button
    >
    <el-form :inline="true" :model="searchForm" style="margin-bottom: 10px">
      <el-form-item label="MVB Product Code">
        <el-input
          v-model="searchForm.mvbProductModel"
          placeholder="Please enter the MVB Product Code"
          clearable
        />
      </el-form-item>
      <el-form-item label="Product Code">
        <el-input
          v-model="searchForm.productModel"
          placeholder="Please enter the Product Code"
          clearable
        />
      </el-form-item>
      <el-form-item label="Product Model">
        <el-input
          v-model="searchForm.productCode"
          placeholder="Please enter the Product Model"
          clearable
        />
      </el-form-item>
      <el-form-item label="barcode">
        <el-input
          v-model="searchForm.barcode"
          placeholder="Please enter the barcode"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">Search</el-button>
        <el-button @click="onReset">Reset</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="filteredOrderDetail" border style="width: 100%">
      <el-table-column
        label="PI ID"
        prop="piNo"
        align="center"
      ></el-table-column>
      <el-table-column
        label="PO ID"
        prop="poNo"
        align="center"
      ></el-table-column>
      <el-table-column
        label="MVB Product Code"
        prop="mvbProductModel"
        align="center"
      ></el-table-column>
      <el-table-column
        label="Product Model"
        prop="productModel"
        align="center"
      ></el-table-column>
      <el-table-column
        label="Product Code"
        prop="productCode"
        align="center"
      ></el-table-column>
      <el-table-column
        label="barcode"
        prop="barcode"
        align="center"
      ></el-table-column>
      <el-table-column
        label="Order Quantity"
        prop="orderQuantity"
        align="center"
      ></el-table-column>
      <el-table-column
        label="Completed Quantity"
        prop="completedQuantity"
        align="center"
      ></el-table-column>
      <el-table-column
        label="Estimated delivery date"
        prop="estimatedDeliveryDate"
        align="center"
        width="200"
      ></el-table-column>
      <!-- 保留交期列 -->
      <el-table-column
        label="Update Time"
        prop="updateTime"
        align="center"
      ></el-table-column>
      <el-table-column label="Progress" align="center">
        <template #default="scope">
          <!-- 进度逻辑：单个货物的已完成数量 / 自身订单数量 * 100 -->
          <el-progress
            :percentage="scope.row.progress * 100"
            size="small"
            show-text
          ></el-progress>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageNum"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handlePageChange"
      style="margin-top: 12px; text-align: right"
    />
  </div>
</template>

<script>
import request from "@/utils/request";
import { Message } from "element-ui"; // 引入Message提示

export default {
  name: "OrderDetail",
  data() {
    return {
      orderDetail: [],
      searchForm: {
        piNo: "",
        mvbProductModel: "",
        productModel: "",
        productCode: "",
        barcode: "",
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      role: "",
    };
  },
  computed: {
    filteredOrderDetail() {
      // const { piNo, mvbProductModel, productModel, productCode, barcode } =
      //   this.searchForm;

      // const match = (value, keyword) => {
      //   if (!keyword) return true;
      //   if (value === null || value === undefined) return false;
      //   return String(value)
      //     .toLowerCase()
      //     .includes(String(keyword).toLowerCase());
      // };

      // return this.orderDetail.filter((item) => {
      //   return (
      //     match(item.piNo, piNo) &&
      //     match(item.mvbProductModel, mvbProductModel) &&
      //     match(item.productModel, productModel) &&
      //     match(item.productCode, productCode) &&
      //     match(item.barcode, barcode)
      //   );
      // });
      return this.orderDetail;
    },
  },
  mounted() {
    this.getOrderDetail();
    this.role = JSON.parse(localStorage.getItem("userInfo")).role;
    console.log(this.role);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getOrderDetail() {
      const { piNo, poNo } = this.$route.query;
      try {
        const res = await request.get("/api/order/detail", {
           params: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            piNo,
            poNo,
            mvbProductModel: this.searchForm.mvbProductModel,
            productModel: this.searchForm.productModel,
            productCode: this.searchForm.productCode,
            barcode: this.searchForm.barcode,
          },
        });
        if (res.code === 200) {
          this.orderDetail = res.records || [];
          this.total = res.total || 0;
        } else {
          if (this.role != "customer") {
            Message.error(res.msg || "查询订单详情失败");
          } else {
            Message.error(res.msg || "Failed to query order details");
          }
        }
      } catch (err) {
        if (this.role != "customer") {
          console.error("查询失败：", err);
          Message.error("网络异常，请重试");
        } else {
          Message.error("Network exception, please try again");
        }
      }
    },
    onSearch() {
      // 依赖 computed 进行过滤，这里只触发视图更新
      // this.searchForm = { ...this.searchForm };
      this.pageNum = 1;
      this.getOrderDetail();
    },
    onReset() {
      this.searchForm = {
        piNo: "",
        mvbProductModel: "",
        productModel: "",
        productCode: "",
        barcode: "",
      };
      this.pageNum = 1;
      this.getOrderDetail();
    },
     handleSizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.getOrderDetail();
    },
    handlePageChange(page) {
      this.pageNum = page;
      this.getOrderDetail();
    },
  },
};
</script>

<style scoped>
.order-detail {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

/* 移除重复的进度文本样式（已用show-text替代） */
</style>